module.exports = __webpack_public_path__ + "static/media/notFoundCharacterKingdom.8c2b755d.svg";